import {
  Badge,
  Flex,
  IconButton,
  Td,
  Text,
  Tr,
  useColorModeValue,
  useToast,
} from "@chakra-ui/react";
import { DeleteIcon, RepeatIcon, CopyIcon } from "@chakra-ui/icons";
import React from "react";
import { API_ROUTES } from "utils/constant";
import { axiosDelete, axiosPatch } from "utils/api";

function ApiKeyRow({ detail, isLast, refetch }) {
  const textColor = useColorModeValue("gray.500", "white");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const toast = useToast();

  async function handleDeactivate() {
    if (!window.confirm(`Vô hiệu hoá key brand ${detail.brand}?`)) return;
    try {
      const res = await axiosDelete(API_ROUTES.ApiKeyDelete(detail._id));
      if (res?.data?.code !== 0) {
        toast({
          title: res?.data?.msg || "Thất bại",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
        return;
      }
      toast({
        title: "Đã vô hiệu hoá",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      refetch?.();
    } catch (error) {
      toast({
        title: error?.response?.data?.msg || "Thất bại",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  }

  async function handleRegenerate() {
    if (
      !window.confirm(
        `Regenerate key brand ${detail.brand}? Client phải cập nhật header x-api-key mới.`
      )
    )
      return;
    try {
      const res = await axiosPatch(API_ROUTES.ApiKeyRegenerate(detail._id), {});
      if (res?.data?.code !== 0) {
        toast({
          title: res?.data?.msg || "Thất bại",
          status: "error",
          duration: 4000,
          isClosable: true,
        });
        return;
      }
      toast({
        title: "Đã regenerate",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      refetch?.();
    } catch (error) {
      toast({
        title: error?.response?.data?.msg || "Thất bại",
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  }

  function handleCopyKey() {
    navigator.clipboard?.writeText(detail.key);
    toast({
      title: "Đã copy key",
      status: "success",
      duration: 2000,
      isClosable: true,
    });
  }

  const created = detail.createdAt
    ? new Date(detail.createdAt).toLocaleString("vi-VN")
    : "-";

  return (
    <Tr>
      <Td
        minWidth={{ sm: "100px" }}
        pl="0px"
        borderColor={borderColor}
        borderBottom={isLast ? "none" : null}
      >
        <Badge colorScheme="purple">{detail.brand}</Badge>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Flex align="center" gap="6px">
          <Text
            fontSize="xs"
            color={textColor}
            fontFamily="mono"
            maxW="280px"
            isTruncated
          >
            {detail.key}
          </Text>
          <IconButton
            size="xs"
            variant="ghost"
            icon={<CopyIcon />}
            onClick={handleCopyKey}
            aria-label="Copy key"
          />
        </Flex>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Text fontSize="sm" color={textColor}>
          {detail.note || "-"}
        </Text>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Badge colorScheme={detail.isActive ? "green" : "red"}>
          {detail.isActive ? "Active" : "Disabled"}
        </Badge>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Text fontSize="sm" color={textColor}>
          {detail.usageCount || 0}
        </Text>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Text fontSize="sm" color={textColor}>
          {created}
        </Text>
      </Td>
      <Td borderColor={borderColor} borderBottom={isLast ? "none" : null}>
        <Flex gap="4px">
          <IconButton
            size="sm"
            variant="ghost"
            colorScheme="blue"
            icon={<RepeatIcon />}
            onClick={handleRegenerate}
            aria-label="Regenerate"
            title="Regenerate key"
          />
          <IconButton
            size="sm"
            variant="ghost"
            colorScheme="red"
            icon={<DeleteIcon />}
            onClick={handleDeactivate}
            aria-label="Deactivate"
            title="Vô hiệu hoá"
            isDisabled={!detail.isActive}
          />
        </Flex>
      </Td>
    </Tr>
  );
}

export default ApiKeyRow;
